import FooterPageMenu from './FooterPageMenu'

export default FooterPageMenu